export default __webpack_public_path__ + "static/media/binance.c1ba96a4.png";